import { Box, IconButton, Paper, Tooltip, Typography } from '@mui/material';
import { Info as InfoIcon } from '@mui/icons-material';
import {
  ComposedChart, Bar, Line, XAxis, YAxis, CartesianGrid,
  Tooltip as RechartsTooltip, Legend, ResponsiveContainer, LabelList
} from 'recharts';

/**
 * Monthly Created vs Resolved bars with the backlog line. Same Recharts setup as the Platform Investigation
 * chart; shared by the L3 Swat (production bugs) and L2 Open views.
 * rows: [{ month, created, resolved }]; backlog: [{ backlog }] in the same order.
 */
const CreatedVsResolvedChart = ({ rows, backlog, info }) => {
  const data = rows.map((r, i) => ({
    month: r.month,
    Created: r.created,
    Resolved: r.resolved,
    Backlog: backlog[i] ? backlog[i].backlog : null
  }));
  return (
    <Paper elevation={2} sx={{ boxSizing: 'border-box', p: 2, height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
        <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
          Monthly Created vs Resolved — Last 12 Months
        </Typography>
        <Tooltip title={info} arrow placement="top">
          <IconButton size="small"><InfoIcon fontSize="small" color="action" /></IconButton>
        </Tooltip>
      </Box>
      <Box sx={{ position: 'relative', flex: '1 1 0', minHeight: 200 }}>
        <Box sx={{ position: 'absolute', inset: 0 }}>
          <ResponsiveContainer width="100%" height="100%">
            <ComposedChart data={data} margin={{ top: 20, right: 20, left: 0, bottom: 4 }}>
              <CartesianGrid strokeDasharray="3 3" vertical={false} />
              <XAxis dataKey="month" tick={{ fontSize: 11 }} />
              <YAxis allowDecimals={false} tick={{ fontSize: 11 }} width={30} />
              <RechartsTooltip />
              <Legend wrapperStyle={{ fontSize: 12 }} />
              <Bar dataKey="Created" fill="#f44336" radius={[3, 3, 0, 0]}>
                <LabelList dataKey="Created" position="top" style={{ fontSize: 10, fontWeight: 600, fill: '#c62828' }} />
              </Bar>
              <Bar dataKey="Resolved" fill="#4caf50" radius={[3, 3, 0, 0]}>
                <LabelList dataKey="Resolved" position="top" style={{ fontSize: 10, fontWeight: 600, fill: '#2e7d32' }} />
              </Bar>
              <Line type="monotone" dataKey="Backlog" stroke="#2196f3" strokeWidth={2} dot={{ r: 4 }} name="Backlog">
                <LabelList dataKey="Backlog" position="top" style={{ fontSize: 10, fontWeight: 600, fill: '#1565c0' }} />
              </Line>
            </ComposedChart>
          </ResponsiveContainer>
        </Box>
      </Box>
    </Paper>
  );
};

export default CreatedVsResolvedChart;
